@use '@design/design-tokens/typography/typography' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.scrollableContainer {
  @include custom-scroll-minimal;
  max-height: min(60vh, 480px);
  overflow-y: auto;
}

.tooltipWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 200px;
  margin-bottom: 12px;
  cursor: pointer;
  padding: 0;

  &:hover {
    background-color: var(--surface-hover);
  }
}

.rightWrapper {
  display: flex;
  flex-direction: column;
}

.titleLabel {
  @include typography-v2-title-sm;
}

.categoryLabel {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}
